/// <reference path="../../../../typings/index.d.ts" />

module Meevo.ChangeTimeZone {
	export class ChangeTimeZoneController {
		context: IChangeTimeZoneContext;

		static $inject = [
			"$window",
			"$mdDialog",
			"meevo.AppSettings",
			"meevo.components.common.IdentityService",
			"meevo.components.common.DataService",
			"meevo.components.modal.ModalService",
			"$translate",
			"meevo.components.busy.BusyService",
			"locationTimeZone"
		];

		constructor(private $window: angular.IWindowService,
			private $mdDialog: angular.material.IDialogService,
			private appSettings: Meevo.Components.Common.IAppSettings,
			private identityService: Meevo.Components.Common.IIdentityService,
			private dataService: Meevo.Components.BaseClasses.IDataService,
			protected modalService: Meevo.Components.Modal.IModalService,
			private $translate: angular.translate.ITranslateService,
			protected busyService: Meevo.Components.Busy.IBusyService,
			private locationTimeZone: any) {
			var handler = () => { this.$mdDialog.hide(); };
			this.context = new ChangeTimeZoneContext(appSettings, dataService, $mdDialog, modalService, identityService, $translate, busyService, handler, locationTimeZone);
		}

		close() {
			this.$mdDialog.cancel();
		}
	}

	angular.module("meevo")
		.controller("meevo.changeTimeZone.ChangeTimeZoneController", ChangeTimeZoneController);
}

